/**
 * @module common/utils/cookie
 */

/**
 * @hideconstructor
 * @classdesc Содержит утилиты для работы с cookie
 */
class Cookie {
  /**
   * @method
   * @description Получить значение cookie по ключу
   * @param {String} key - Ключ cookie
   * @returns {String | null}
   */
  static get(key) {
    let result;
    const cookies = document.cookie ? document.cookie.split('; ') : [];

    for (const cookie of cookies) {
      const parts = cookie.split('=');
      const name = parts.shift();

      if (key === name) {
        result = parts.pop();
        break;
      }
    }

    return result || null;
  }
}

export default Cookie;
